// FutureLab
import { store } from '../configureStore';
import { chatApi } from '../store/api/chatApi';

// 3rd Party
import axios from 'axios';


const createDownloadLink = (url: string, fileName: string) => {
	const linkElement = document.createElement('a');
	linkElement.href = url;
	linkElement.setAttribute('download', fileName);
	return linkElement;
};

const fetchAttachment = async (url: string) => {
	try {
    const response = await axios.get(url, { responseType: 'blob' });
    return new Blob([response.data]);
  } catch (error) {
    throw new Error(`Failed to fetch Attachment`);
  }
};

export const downloadAttachment = async (attachment: { key: string; fileName: string }) => {
	const downloadLink = createDownloadLink('', attachment.fileName);

	try {
		const renewedAttachment = await store.dispatch(chatApi.endpoints.renewAttachment.initiate(attachment)).unwrap();
		const renewedAttachmentData = await fetchAttachment(renewedAttachment.key);

		const renewedAttachmentUrl = window.URL.createObjectURL(renewedAttachmentData);
		downloadLink.href = renewedAttachmentUrl;

		document.body.appendChild(downloadLink);
		downloadLink.click();
	} catch (error) {
		console.error(error);
	} finally {
		if (downloadLink.isConnected) document.body.removeChild(downloadLink);
	}
};
